import {
    googleReportCacheKey,
    metaReportCacheKey,
} from './marketingAdsCacheKey';

/**
 * Read one cached report entry.
 *
 * New shape:  state.marketingAds.meta.entries[cacheKey]
 * Legacy shape (persisted before the multi-entry cache): the channel held
 * a single { cacheKey, campaigns, ... } object. It is honoured as a
 * one-entry cache so an upgrade does not force a reload.
 */
function channelEntry(channelState, cacheKey) {
    if (!channelState || !cacheKey) return null;
    if (channelState.entries) return channelState.entries[cacheKey] || null;
    if (channelState.cacheKey && channelState.cacheKey === cacheKey) return channelState;
    return null;
}

export function selectMetaEntry(state, from, to, platform = 'both') {
    return channelEntry(
        state?.marketingAds?.meta,
        from && to ? metaReportCacheKey(from, to, platform) : '',
    );
}

export function selectGoogleEntry(state, from, to) {
    return channelEntry(
        state?.marketingAds?.google,
        from && to ? googleReportCacheKey(from, to) : '',
    );
}

/** Lead targets are date-independent: they live at channel level, not per entry. */
export function selectMetaTargets(state) {
    const meta = state?.marketingAds?.meta;
    if (!meta) return {};
    if (meta.targets && Object.keys(meta.targets).length) return meta.targets;
    // Legacy: targets were stored on the single cached entry.
    const entries = meta.entries ? Object.values(meta.entries) : [meta];
    const withTargets = entries.find((entry) => entry?.targets && Object.keys(entry.targets).length);
    return withTargets?.targets || meta.targets || {};
}

export function selectGoogleTargets(state) {
    const google = state?.marketingAds?.google;
    if (!google) return {};
    if (google.targets && Object.keys(google.targets).length) return google.targets;
    const entries = google.entries ? Object.values(google.entries) : [google];
    const withTargets = entries.find((entry) => entry?.targets && Object.keys(entry.targets).length);
    return withTargets?.targets || google.targets || {};
}
